// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38uJ_","col":"styles_col__2llQ4"};